import useErrorDashboard from 'hooks/error/useErrorDashboard';
import styled from 'styled-components';

const ErrorDashboard = () => {
  const { errorDashboard } = useErrorDashboard();

  return (
    <ErrorDashboardBlock>
      <div className="box">
        <div className="error-dashboard-box-header">
          <div>장소</div>
          <div>제품</div>
          <div>상태</div>
        </div>
        <div className="error-dashboard-box-row">
          <div className="error-dashboard-box-cell">
            <div className="font-l">{errorDashboard?.countStore}</div>
          </div>
          <div className="error-dashboard-box-cell">
            <div>허브 ({errorDashboard?.countMaster})</div>
            <div>온습도 센서 ({errorDashboard?.countSensor})</div>
            <div>컨트롤러 ({errorDashboard?.countController})</div>
          </div>
          <div className="error-dashboard-box-cell">
            <div>배터리 부족 ({errorDashboard?.batteryIsuue})</div>
            <div>연결 끊김 ({errorDashboard?.disconnection})</div>
          </div>
        </div>
      </div>
    </ErrorDashboardBlock>
  );
};

export default ErrorDashboard;

const ErrorDashboardBlock = styled.div`
  .error-dashboard-box-header {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    div {
      width: 33%;
      text-align: center;
    }
  }

  .error-dashboard-box-row {
    margin: 1rem 0;
    display: flex;
    font-size: 12px;
    font-weight: 600;
  }

  .error-dashboard-box-cell {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    div + div {
      margin-top: 5px;
    }
  }
`;
